<template>
  <div class="activityContent">
    <div class="banner">
      <div class="bannerStyle">
        <img src="static/image/banner.png" />
      </div>
    </div>
    <div class="recommend">
      <img src="static/image/recommend_bg.png" />
      <div class="bg">
        <div class="myRecommend">我的邀请码</div>
        <div
          @click="copy"
          class="tag-read"
          :data-clipboard-text="recommendData"
        >
          <Input
            readonly="readonly"
            v-model="recommendData"
            style="width: 60%"
          />
          <!-- <span>复制</span> -->
        </div>
      </div>
    </div>
    <div class="activityList">
      <div class="activityListDiv">
        <div class="activityButton">活动一</div>
        <div>
          <p>用户关注公众号</p>
          <p>按照要求转发推文到朋友圈</p>
          <p>截图发给后台</p>
          <p>即可获取优惠码</p>
        </div>
      </div>
      <div class="activityListDiv">
        <div class="activityButton">活动二</div>
        <div>
          <p>老用户邀请新用户</p>
          <p>邀请一个送三天，两个送七天，三个送一个月</p>
          <p>三个以后每邀请一个就送一个月</p>
          <p>邀请的新用户首充后</p>
          <p>老用户再送一个月</p>
          <p>累计叠加，邀请越多，送的越多</p>
        </div>
      </div>
    </div>
    <div class="activityOne">
      <div class="activityTitleOne">活动一</div>
      <div class="activityOneContent">
        <Row>
          <Col span="6">
            <div class="phoneTitle">1.关注微信公众号</div>
            <img src="static/image/phone_1.png" />
          </Col>
          <Col span="6">
            <div class="phoneTitle">2.点击下方获取抵扣码</div>
            <img src="static/image/phone_4.png" />
          </Col>
          <Col span="6">
            <div class="phoneTitle">3.按要求转发推文到朋友圈等</div>
            <img src="static/image/phone_2.png" />
          </Col>
          <Col span="6">
            <div class="phoneTitle">3.截图发送至后台</div>
            <img src="static/image/phone_3.png" />
          </Col>
        </Row>
      </div>
      <div class="activityDescription">
        <div class="activityDescriptionTitle">活动说明：</div>
        <p>1.关注微信公众号；</p>
        <p>
          2.点击下方<b>抵扣码</b>，按要求将指定的文章分享到微信朋友圈等；
        </p>

        <p>3.截图发给后台；</p>
        <p>4.获取优惠码；</p>
        <p>5.开通会员时输入优惠码即可使用</p>
        <p>6.优惠码在获取后3天内有效，过期自动失效请及时使用；</p>
        <p>7.活动期限：2020年9月1日-2020年11月1日；</p>
        <p>8.本次活动最终解释权归万灵数据科技有限公司所有。</p>
      </div>
    </div>

    <div class="activityTwo">
      <div class="activityTitleTwo">活动二</div>
      <div class="activityTwoContent">
        <Row>
          <Col span="8">
            <div class="phoneTitle">1.用户注册，每个用户拥有一个专属邀请码</div>
            <img src="static/image/activity_1.png" />
          </Col>
          <Col span="8">
            <div class="phoneTitle">2.老用户邀请新用户</div>
            <img src="static/image/activity_2.png" />
          </Col>
          <Col span="8">
            <div class="phoneTitle">3.新用户注册时，填写邀请码</div>
            <img src="static/image/activity_3.png" />
          </Col>
        </Row>
      </div>
      <div class="activityDescription">
        <div class="activityDescriptionTitle">活动说明：</div>
        <p>1.每个用户注册时都会有一个专属的邀请码；</p>
        <!-- <p>2.新用户在注册时填写邀请码，购买时将会有相应的折扣；</p> -->
        <p>
          2.老用户成功邀请一个人注册可以获得3天的使用时间，两个可以获得七天的使用时间，3个可以获得一个月的使用时间（会员自动到账）；
        </p>
        <br />
        <p>
          3.老用户邀请超过三个后每邀请一个便可获得一个月的使用时间，多邀多得，上不封顶；
        </p>
        <p>4.老用户邀请的新用户首次充值，老用户可以获得一个月的使用时间；</p>
        <p>5.用户获得的时间时累计叠加的；</p>
        <p>6.活动期限：2020年9月1日-长期；</p>
        <p>7.如有疑问，请联系客服，邮箱: graves@willingdata.com；</p>
        <p>8.本次活动最终解释权归万灵数据科技有限公司所有。</p>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      recommendData: "asdsas"
    };
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", e => {
        // console.log("复制成功");
        this.$Message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        // console.log("该浏览器不支持自动复制");
        this.$Message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
// @import "../../../public/static/style/page.less";
.activityContent {
  width: 100%;
}
.banner {
  width: 100%;
  height: 200px;
  background-color: #257dfd;
  .bannerStyle {
    // width: 800px;
    width: 800px;
    height: auto;
    margin: 0 auto;
    img {
      width: 100%;
      height: auto;
      margin-top: 20px;
    }
  }
}
.recommend {
  width: 400px;
  height: 150px;
  text-align: center;
  margin: 20px auto;
  .bg {
    margin-top: -120px;
  }
  .myRecommend {
    color: #409eff;
    font-size: 16px;
    font-weight: bold;
  }
  img {
    width: 100%;
    height: 150px;
  }
}
.activityList {
  width: 800px;
  margin: 0 auto;
  display: flex;
  .activityListDiv {
    width: 400px;
    text-align: center;
    font-weight: bold;
    .activityButton {
      width: 180px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 18px;
      background-color: #409eff;
      border-radius: 20px;
      margin: 10px auto;
    }
  }
}
.activityOne {
  width: 100%;
  background-color: #47a2ff;

  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
  .activityOneContent {
    width: 800px;
    margin: 0 auto;
  }
  .activityTitleOne {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 180px;
    height: 40px;
    line-height: 35px;
    border-radius: 20px;
    border: 2px solid #fff;
    text-align: center;
    margin: 0 auto;
  }
  .activityOneContent {
    color: #fff;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    .phoneTitle {
      height: 40px;
      line-height: 40px;
    }
    img {
      width: 80%;
    }
  }
  .activityDescription {
    color: #fff;
    width: 800px;
    margin: 25px auto;
    .activityDescriptionTitle {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      height: 25px;
      line-height: 25px;
    }
  }
}

.activityTwo {
  width: 100%;

  padding-top: 20px;
  margin-top: 20px;
  .activityTwoContent {
    width: 800px;
    margin: 0 auto;
    .phoneTitle {
      width: 150px;
      height: 50px;
      text-align: left;
      margin: 10px auto;
    }
  }
  .activityTitleTwo {
    color: #409eff;
    font-size: 18px;
    font-weight: bold;
    width: 180px;
    height: 40px;
    line-height: 35px;
    border-radius: 20px;
    border: 2px solid #409eff;
    text-align: center;
    margin: 0 auto;
  }
  .activityTwoContent {
    color: #409eff;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    img {
      width: 150px;
      height: 130px;
      margin-top: 20px;
    }
  }
  .activityDescription {
    color: #409eff;
    width: 800px;
    margin: 25px auto;
    .activityDescriptionTitle {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      height: 25px;
      line-height: 25px;
    }
  }
}
@media screen and (min-width: 960px) {
  .banner {
    width: 100%;
    height: auto;
    background-color: #257dfd;
    .bannerStyle {
      width: 60%;
      height: auto;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
        margin-top: 20px;
        margin-bottom: 30px;
      }
    }
  }
  .activityOne {
    width: 100%;
    background-color: #47a2ff;

    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 20px;
    .activityOneContent {
      width: 60%;
      margin: 0 auto;
    }
    .activityTitleOne {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 180px;
      height: 40px;
      line-height: 35px;
      border-radius: 20px;
      border: 2px solid #fff;
      text-align: center;
      margin: 0 auto;
    }
    .activityOneContent {
      color: #fff;
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
      .phoneTitle {
        height: 40px;
        line-height: 40px;
      }
      img {
        width: 80%;
      }
    }
    .activityDescription {
      color: #fff;
      width: 60%;
      margin: 25px auto;
      .activityDescriptionTitle {
        font-size: 20px;
        font-weight: bold;
      }
      p {
        height: 25px;
        line-height: 25px;
      }
    }
  }
  .activityTwo {
    width: 100%;

    padding-top: 20px;
    margin-top: 20px;
    .activityTwoContent {
      width: 60%;
      margin: 0 auto;
      .phoneTitle {
        width: 150px;
        height: 50px;
        text-align: left;
        margin: 10px auto;
      }
    }
    .activityTitleTwo {
      color: #409eff;
      font-size: 18px;
      font-weight: bold;
      width: 180px;
      height: 40px;
      line-height: 35px;
      border-radius: 20px;
      border: 2px solid #409eff;
      text-align: center;
      margin: 0 auto;
    }
    .activityTwoContent {
      color: #409eff;
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
      img {
        width: 150px;
        height: 130px;
        margin-top: 20px;
      }
    }
    .activityDescription {
      color: #409eff;
      width: 60%;
      margin: 25px auto;
      .activityDescriptionTitle {
        font-size: 20px;
        font-weight: bold;
      }
      p {
        height: 25px;
        line-height: 25px;
      }
    }
  }
}
</style>
